var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import { Translate } from "../../I18N";
import React, { useCallback, useRef, useState } from 'react';
import { Icon } from "../../UI";

import debounce from "../../utils/debounce";
import { MemberListItemInfo } from "./MemberListItemInfo";







export const UserGroupsLookupField = ({
  onChange,
  onSelect,
  options
}) => {
  const [selected, setSelected] = useState(null);
  const [show, setShow] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedOnChange = useCallback(debounce(onChange, 500), [onChange]);

  const onChangeHandler = (event) => {
    setShow(true);
    setSearchTerm(event.target.value);
    debouncedOnChange(event.target.value);
  };

  const getOnSelectHandler = (selection) => () => {
    onSelect(selection);
    setShow(false);
  };

  const onKeyPressHandler = (event) => {
    switch (event.key) {
      case 'ArrowUp':
        event.preventDefault();
        if (!selected) {
          setSelected(options.length - 1);
        } else {
          setSelected((selected - 1) % options.length);
        }

        break;
      case 'ArrowDown':
        event.preventDefault();
        if (selected === null) {
          setSelected(0);
        } else {
          setSelected((selected + 1) % options.length);
        }

        break;
      case 'Enter':
        event.preventDefault();
        if (selected !== null) {
          onSelect(options[selected]);
          setShow(false);
        }
        break;
      case 'Escape':
        event.preventDefault();
        setShow(false);
        break;
      default:
        break;
    }
  };

  const optionsListRef = useRef(null);

  return /*#__PURE__*/(
    _jsx("div", { className: "userGroupsLookupField" }, void 0, /*#__PURE__*/
    _jsx("input", {
      type: "text",
      placeholder: "Add people or groups",
      onChange: onChangeHandler,
      onKeyDown: onKeyPressHandler,
      onBlur: (e) => {
        if (e.relatedTarget !== optionsListRef.current) {
          setShow(false);
        }
      },
      onFocus: () => {
        setShow(true);
      },
      value: searchTerm }
    ),
    show && options.length ? /*#__PURE__*/
    React.createElement("ul", { tabIndex: -1, role: "listbox", ref: optionsListRef },
    options.map((result, index) => /*#__PURE__*/
    _jsx("li", {

      role: "option",
      "aria-selected": index === selected,
      onClick: getOnSelectHandler(result),
      className: index === selected ? 'selected' : '' }, `${result.type}-${result.refId}`, /*#__PURE__*/

    _jsx(MemberListItemInfo, { value: result }), /*#__PURE__*/
    _jsx("div", { className: "press-enter-note" }, void 0, /*#__PURE__*/
    _jsx("span", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Press enter to add")
    ), /*#__PURE__*/
    _jsx(Icon, { icon: "level-down-alt", transform: { rotate: 90 } })
    )
    )
    )
    ) :
    null
    ));

};